export default {
  zoomToFit: 'Rozwiń, aby dopasować',
  arrangeNodes: 'Zorganizować',
  zoomIn: 'Powiększ',
  zoomOut: 'Oddal',
  more: 'Więcej funkcji',
  backgroundContextMenu: {
    addNode: {
      title: 'Dodaj węzeł',
      emitter: 'Emiter',
      function: 'Funkcja',
      operator: 'Operator',
      variable: 'Zmienna',
    },
    preview: {
      title: 'Podgląd',
      hideAll: 'Wyłącz wszystkie',
    },
  },
};
